export { default as ParagraphDisplay } from './ParagraphDisplay';
export type { ParagraphDisplayProps } from './ParagraphDisplay';
